import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Payment from "./Payment.jsx";
import BankAccount from "./BankAccount.jsx";
import ProfileContext from "../../ProfileContext.jsx";
import AppContext from "../../../../AppContext.jsx";
import { langComponent } from "../../../../constants/index.jsx";

const Billing = () => {
  const { user } = useContext(ProfileContext);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.profile);
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (!user) return;
  }, [user]);

  const tabs = [
    {
      id: 0,
      value: "Payment Method",
    },
    {
      id: 1,
      value: "Bank Accounts",
    },
  ];

  const getContentToRender = () => {
    if (currentTab === 0) {
      return <Payment />;
    }

    if (currentTab === 1) {
      return <BankAccount />;
    }
  };

  const handleSwitchTab = (tabId) => {
    setCurrentTab(tabId);
  };

  return (
    <div className="profile-edit-billing">
      <div className="profile-edit-billing-tabs">
        {tabs.map(({ id, value }) => (
          <div
            className={`profile-edit-billing-tabs__tab${
              id === currentTab ? " profile-edit-billing-tabs__tab--active" : ""
            }`}
            key={`profile-edit-billing-tab-${id}`}
            onClick={() => handleSwitchTab(id)}
          >
            {Translation(value)}
          </div>
        ))}
      </div>
      <div className="profile-edit-billing-content">{getContentToRender()}</div>
    </div>
  );
};

Billing.propTypes = {};

export default Billing;
